import React, { useState, useEffect } from 'react';
import '../App.css';
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import search from '../assets/search_white.png';
import Api from './api/api'
import MyLoader from './util/loader'
import MyError from './util/error'
import showToast from './util/toast'
import { ToastContainer, toast } from 'react-toastify';

const Patients = () => {
    const [verified, setVerified] = useState(0);
    const [unverified, setUnverified] = useState(0);
    const [models, setModels] = useState([]);
    const [tempModels, setTempModels] = useState([]); // array of symbols
    const [keyword, setKeyword] = useState('');
    const [loader, setLoader] = useState(false);

    // load data
    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setLoader(true)
        Api.getPatients(
            (patients) => {
                console.log('patients: ' + patients.length);
                let models = []
                let unver = 0
                let ver = 0
                for (let i = 0; i < patients.length; i++) {
                    const patient = patients[i];
                    models.push(patient)
                    if (patient.status === 'verified' || patient.status === 'active') {
                        ver++
                    }
                    else {
                        unver++
                    }
                }
                setLoader(false)
                setModels(models)
                setUnverified(unver)
                setVerified(ver)
            },
            (error) => {
                setLoader(false)
                showToast('error', error)
            })
    };

    const verifyPatient = (model) => {
        setLoader(true)
        Api.updatePatientStatus(model.email, 'verified',
            () => {
                setLoader(false)
                const temp = models.map((item) => {
                    if (item.email === model.email) {
                        return { ...item, status: 'verified' };
                    }
                    else {
                        return item;
                    }
                });
                setModels(temp)
                setVerified(verified + 1)
                setUnverified(unverified - 1)
                Api.sendVerifiedEmail(model)
            },
            (error) => {
                setLoader(false)
                showToast('error', error)
            })
    };

    const declineDoctor = (model) => {
        setLoader(true)
        Api.updatePatientStatus(model.email, 'declined',
            () => {
                setLoader(false)
                const temp = models.map((item) => {
                    if (item.email === model.email) {
                        return { ...item, status: 'declined' };
                    }
                    else {
                        return item;
                    }
                });
                setModels(temp)
                setUnverified(unverified + 1)
                setVerified(verified - 1)
            },
            (error) => {
                setLoader(false)
                showToast('error', error)
            })
    };

    const searchUsers = (keyword) => {
        let arr = [...models]
        let arrTemp = [...tempModels]
        if (arrTemp.length == 0) {
            arrTemp = arr
        }

        arr = []

        if (keyword === '') {
            arr = arrTemp
        }
        else {
            arrTemp.find((model) => {
                if (model.email.toLowerCase().includes(keyword.toLowerCase()) || model.name.toLowerCase().includes(keyword.toLowerCase())) {
                    arr.push(model);
                }
            });
        }

        setModels(arr)
        setTempModels(arrTemp)
        setKeyword(keyword)
    };

    const exportDoctors = () => {

    }

    const deleteUser = (model) => {
        let flag = window.confirm('Are you sure you want to delete this patient?')
        if (flag) {
            let id = model.id
            Api.deletePatient(model, () => { })
            const newModels = models.filter((item, j) => {
                return item.id !== id; //false will delete
            })
            setModels(newModels)
        }
    }

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Patients ({models.length})
                </div>
            </div>

            <div style={{ display: 'flex', marginBottom: -10, marginTop: 0, alignItems: 'center', justifyContent: 'center' }}>
                <FormGroup
                    style={{ width: 400, marginTop: 20 }}>
                    <Input
                        type='email'
                        placeholder='Search by email or name...'
                        value={keyword}
                        onChange={(event) => {
                            setKeyword(event.target.value)
                        }} />
                </FormGroup>
                <div style={{ backgroundColor: 'black', width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 20, marginLeft: 10 }}>
                    <img
                        onClick={() => {
                            console.log('click');
                            searchUsers(keyword)
                        }}
                        src={search}
                        style={{ width: 30, height: 30 }}
                        className='icon-btn' />
                </div>
            </div>

            <div style={{ display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center' }}>
                <div
                    style={{ borderRadius: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 150, fontSize: 16, border: '1px solid red', color: 'white' }}>
                    <div style={{ color: 'red', fontSize: 20, fontWeight: 'bold' }}>
                        {unverified}
                    </div>
                    <div style={{ color: 'red', fontSize: 12 }}>
                        Blocked
                    </div>
                </div>
                <div
                    style={{ borderRadius: 10, marginLeft: 10, marginRight: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 150, fontSize: 16, border: '1px solid green', color: 'white' }}>
                    <div style={{ color: 'green', fontSize: 20, fontWeight: 'bold' }}>
                        {verified}
                    </div>
                    <div style={{ color: 'green', fontSize: 12 }}>
                        Active
                    </div>
                </div>
            </div>

            <div style={{ marginTop: 10 }}></div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', overflow: 'scroll', }}>
                {models.map((model, index) => {
                    return (
                        <div style={{ display: 'flex', marginRight: 15, marginBottom: 15, backgroundColor: '#fff', padding: 10, borderRadius: 10, width: '45%' }}>
                            <div style={{ marginTop: 0, display: 'flex' }}>
                                <div style={{}}>
                                    {/* <div style={{ fontSize: 16, fontWeight: 'bold', color: 'green' }}>#{index + 1}</div> */}
                                    <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Name:</div> {model.name}</div>
                                    <div style={{ fontSize: 16, display: 'flex' }}>
                                        <div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Email:</div>
                                        <button
                                            style={{ fontSize: 16, marginTop: -1, color: 'blue', borderWidth: 0, backgroundColor: 'transparent', marginLeft: -6 }}
                                            onClick={() => {
                                                window.open("mailto:" + model.email);
                                            }}>
                                            {model.email}
                                        </button>
                                    </div>
                                    <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Phone:</div> {model.phone}</div>

                                    <div style={{ display: 'flex', fontSize: 16, marginBottom: 10 }}>
                                        <div style={{ fontWeight: 'bold' }}>Status:</div>
                                        <div style={{ marginLeft: 10, color: model.status === 'pending' ? 'blue' : model.status === 'declined' ? 'red' : 'green' }}>{model.status}</div>
                                    </div>

                                    {model.status === 'pending' ? // pending/declined/verified
                                        <div style={{ display: 'flex' }}>
                                            <Button
                                                className='btn-block btn-submit'
                                                style={{ width: 100, fontSize: 16, backgroundColor: 'green', color: 'white' }}
                                                onClick={() => {
                                                    console.log('click');
                                                    verifyPatient(model)
                                                }}>
                                                Verify
                                            </Button>
                                            <Button
                                                className='btn-block btn-submit'
                                                style={{ marginLeft: 10, width: 100, fontSize: 16, backgroundColor: 'red', color: 'white' }}
                                                onClick={() => {
                                                    console.log('click');
                                                    declineDoctor(model)
                                                }}>
                                                Decline
                                            </Button>
                                        </div>
                                        :
                                        model.status === 'declined' ?
                                            <Button
                                                className='btn-block btn-submit'
                                                style={{ width: 100, fontSize: 16, backgroundColor: 'green', color: 'white' }}
                                                onClick={() => {
                                                    console.log('click');
                                                    verifyPatient(model)
                                                }}>
                                                Activate
                                            </Button>
                                            :
                                            <Button
                                                className='btn-block btn-submit'
                                                style={{ width: 100, fontSize: 16, backgroundColor: 'red', color: 'white' }}
                                                onClick={() => {
                                                    console.log('click');
                                                    declineDoctor(model)
                                                }}>
                                                Block
                                            </Button>
                                    }
                                    <Button
                                        className='btn-block btn-submit'
                                        style={{ width: 100, marginLeft: 10, fontSize: 16, backgroundColor: 'black', color: 'white' }}
                                        onClick={() => {
                                            console.log('click');
                                            deleteUser(model)
                                        }}>
                                        Delete
                                    </Button>
                                </div>

                            </div>

                        </div>
                    );
                })}
            </div>

            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default Patients;